import React from "react";
import { endOfDay } from "date-fns";
import { startOfDay } from "date-fns/esm";
import { ICalendar } from "../../domain/calendars/ICalendar";
import { ICalendarEvent } from "../../domain/calendars/ICalendarEvent";
import { dateFormat, dateOverlap, datesEqual } from "../../helpers/dateHelpers";
import { BaseComponent } from "../core/BaseComponent";
import { MonthDay } from "./MonthDay";

interface AbsenceMonthRowProps {
    calendar: ICalendar;
    isCurrentUser: boolean;
    colWidth: string;
    daysOfMonth: Date[];
}
export class AbsenceMonthRow extends BaseComponent<AbsenceMonthRowProps> {

    getFilteredAbsences(date: Date) {
        return this.props.calendar.calendarEvents.filter(x => this.filterAbsenceOnDate(date, x));
    }
    filterAbsenceOnDate(date: Date, absence: ICalendarEvent): boolean {
        const overlap = dateOverlap(absence.start, absence.end, startOfDay(date), endOfDay(date));
        return overlap > 0
    }
    getAmountOfHours(absences: ICalendarEvent[]): number {
        const amountOfHours = absences.reduce((a, b) => a + (b.end.getTime() - b.start.getTime()), 0) / 1000 / 60 / 60;
        return Math.ceil(Math.min(amountOfHours, 7.5));
    }

    getAbsenceDescription(absence: ICalendarEvent) {
        let dateAsString = "";
        if (!datesEqual(absence.start, absence.end)) {
            dateAsString = `${dateFormat(absence.start, "dd-M-yyyy")} - ${dateFormat(absence.end, "dd-M-yyyy")}`;
        } else {
            dateAsString = `${dateFormat(absence.start, "HH:mm")} - ${dateFormat(absence.end, "HH:mm")}`;
        }

        const status = this.translate(`calendarEventStatus.${absence.status}`);
        return `${dateAsString}: ${status} (${absence.description})`;
    }

    CreateGuid() {
        function _p8(s: any) {
            var p = (Math.random().toString(16) + "000000000").substr(2, 8);
            return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
        }
        return _p8(null) + _p8(true) + _p8(true) + _p8(null);
    }
    getDay(date: Date): JSX.Element {
        const absences = this.getFilteredAbsences(date);
        const hours = this.getAmountOfHours(absences);
        const content = hours > 3 ? `${hours}u` : '';
        const tooltip = <div>{absences.map((x, i) => <div className="absence-hover-list" key={`${i}-${x.start.getTime()}-${x.end.getTime()}`}> {this.getAbsenceDescription(x)} </div>)}</div>;
        const classes: string[] = [];
        if (hours > 6) {
            classes.push("full-absent");
        } else if (hours > 3) {
            classes.push("half-absent");
        }

        return <MonthDay key={`${date}`} date={date} width={this.props.colWidth} classes={classes}>
            {/* <div data-for={uniekId} data-tip> {content}</div> */}
            <div className="a-tooltip ">
                <span>{content}</span>
                <span className="tooltiptext left">{tooltip}</span>
            </div>
            {/* <ReactTooltip id={uniekId} type='dark'>
                <div>{absences.map((x, i) => <div className="absence-hover-list" key={`${i}-${x.start.getTime()}-${x.end.getTime()}`}> {this.getAbsenceDescription(x)} </div>)}</div>
            </ReactTooltip> */}
        </MonthDay>
    }
    render() {
        const employee = this.props.calendar;
        const classes = ["employee-absence"];
        if (this.props.isCurrentUser) classes.push("current-user");

        let employeeName = employee.name;
        const dates = this.props.daysOfMonth.map(d => this.getDay(d));
        return (<tr className={classes.join(" ")}>
            <td className="dagcell employee-name" style={{ width: "20%" }}>{employeeName}</td>
            {dates}
        </tr>);
    }
}
